export const MANROPE = { fontFamily: "Manrope, sans-serif" };

export const TONE = {
  red: { ink: "#D24317", edge: "#D24317" },
  amber: { ink: "#8A6D00", edge: "#E8B400" },
  green: { ink: "#1E6B3A", edge: "#2E8B52" },
  neutral: { ink: "#1A1A1A", edge: "#DAD5CA" },
};

export const toneOf = (t) => TONE[t] || TONE.neutral;

export const BAND_INK = { white: "#FFFFFF", amber: "#FFD108", orange: "#FF7A4D" };

export const LABEL = "text-[10px] font-bold uppercase tracking-[0.12em] text-[#8A857C]";
